import { defineResource } from 'pulse/resources';
import { defaultCrmObjectResolver } from './resolver';

/**
 * Get all of a CrmObject's property values, plus the current user's permissions.
 */
export const CrmObject = defineResource({
  typeName: 'hs-resources:CrmObject',
  args: ['objectTypeId', 'objectId'],
  resolver: defaultCrmObjectResolver
}).register();